import { wrapStyleTagSelectorsWithRootSelector } from '@epicuro-next/elements/core';

export function transformStyleTagContents(
  rawHTML: string,
  selector: string,
): string {
  const doc = new DOMParser().parseFromString(rawHTML, 'text/html');

  let result = '';

  doc.querySelectorAll('style').forEach((node) => {
    const safeStyleContent = wrapStyleTagSelectorsWithRootSelector(
      node.innerHTML.trim(),
      selector,
    );
    result += `<style>${safeStyleContent}</style>`;
  });

  const ungreedyStyleTagMatcher = /(<style[\w\W]+?style>)/g;
  result += (rawHTML ?? '').replace(ungreedyStyleTagMatcher, '');

  return result;
}
